// extracted by mini-css-extract-plugin
module.exports = {"detailsArea":"detailsArea___hDb2Z","highlight":"highlight___2DfwK"};